import { useEffect, useRef } from 'react'
import { FormikHelpers } from 'formik'
import { LocationAddressType } from '../types'
import { EMPTY_GEOCODED_FIELD } from '../helpers/location-address'

export const useClearLocationFieldsOnTypeChange = (
  addressType: LocationAddressType | undefined,
  setFieldValue: FormikHelpers<unknown>['setFieldValue'],
) => {
  const previousType = useRef(addressType)

  useEffect(() => {
    const previous = previousType.current
    if (previous !== undefined && previous !== addressType) {
      if (addressType === LocationAddressType.AddressAndCoords) {
        setFieldValue('plusCode', EMPTY_GEOCODED_FIELD)
        setFieldValue('locationDetails', null)
      } else if (addressType === LocationAddressType.PlusCode) {
        setFieldValue('address', EMPTY_GEOCODED_FIELD)
        if (previous === LocationAddressType.CustomTextOnly) {
          setFieldValue('locationDetails', '')
        }
      } else {
        setFieldValue('address', EMPTY_GEOCODED_FIELD)
        setFieldValue('plusCode', EMPTY_GEOCODED_FIELD)
        if (previous === LocationAddressType.PlusCode) {
          setFieldValue('locationDetails', '')
        }
      }
    }
    previousType.current = addressType
  }, [addressType, setFieldValue])
}
